
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'expert': {
    width: 58,
    height: 45.402,
    viewBox: '0 0 58 45.402',
    data: '<g data-name="Groupe 4342" _fill="#ff2d55" _stroke="#aebece"><g data-name="Rectangle 881" transform="translate(0 30.402)"><rect pid="0" width="16" height="15" rx="3" _stroke="none"/><rect pid="1" x=".5" y=".5" width="15" height="14" rx="2.5" _fill="none"/></g><g data-name="Rectangle 882" transform="translate(21 15.402)"><rect pid="2" width="16" height="30" rx="3" _stroke="none"/><rect pid="3" x=".5" y=".5" width="15" height="29" rx="2.5" _fill="none"/></g><g data-name="Rectangle 883" transform="translate(42)"><rect pid="4" width="16" height="45" rx="3" _stroke="none"/><rect pid="5" x=".5" y=".5" width="15" height="44" rx="2.5" _fill="none"/></g></g>'
  }
})
